import React, { useState, useEffect } from 'react';
import { LogoIcon } from './Icons';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 32);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Menu', href: '#menu' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <nav className={`fixed w-full top-0 z-50 backdrop-blur-md bg-black/60 transition-all duration-300 ${
      isScrolled ? 'shadow-xl' : ''
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3 sm:py-4">
          {/* Logo */}
          <div 
            className="flex-shrink-0 cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <LogoIcon className="h-8 sm:h-10 hover:animate-flicker transition-all duration-200" />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <ul className="flex gap-8 items-center">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-ivory hover:text-neonBlue transition-colors duration-200 
                               font-medium hover:drop-shadow-neonBlue"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#order"
                  className="bg-neonRed text-white px-4 py-2 rounded shadow-neonRed 
                             hover:animate-flicker hover:-translate-y-0.5 transition-all 
                             duration-200 font-semibold min-h-[44px] inline-flex items-center"
                >
                  Order Online
                </a>
              </li>
            </ul>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-ivory hover:text-neonBlue transition-colors duration-200 p-2"
              aria-label="Toggle mobile menu"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 border-t border-gray/20">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="block px-3 py-2 text-ivory hover:text-neonBlue transition-colors 
                             duration-200 font-medium hover:drop-shadow-neonBlue"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a
                href="#order"
                className="block w-full text-center bg-neonRed text-white px-4 py-3 mt-4 
                           rounded shadow-neonRed hover:animate-flicker transition-all 
                           duration-200 font-semibold"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Order Online
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 